<template>
  <div class="propertyDetail">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">标的物详情</div>
      </div>

      <div class="table-container detail-body" v-loading="loading">
        <!-- 标的物信息 -->
        <div class="detail-section">
          <div class="detail-section-title">标的物信息</div>
          <div class="detail-grid3">
            <div class="detail-row">
              <span class="detail-label">标的物编号</span>
              <span class="detail-value">{{ detail.propertyCode || "-" }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">标的物类型</span>
              <span class="detail-value">{{ typeLabel }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">面积(亩)</span>
              <span class="detail-value">{{ detail.area != null && detail.area !== "" ? detail.area : "-" }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">详细地址</span>
              <span class="detail-value">{{ detail.address || "-" }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">使用状态</span>
              <span class="detail-value">
                <LeaseStatusTag kind="property" :value="detail.status" />
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">审核状态</span>
              <span class="detail-value">
                <LeaseStatusTag kind="audit" :value="detail.auditStatus" />
              </span>
            </div>
            <div v-if="detail.auditRemark" class="detail-row detail-row-full">
              <span class="detail-label">驳回原因</span>
              <span class="detail-value detail-value-danger">{{ detail.auditRemark }}</span>
            </div>
            <div v-if="detail.disableReason" class="detail-row detail-row-full">
              <span class="detail-label">禁用原因</span>
              <span class="detail-value">{{ detail.disableReason }}</span>
            </div>
            <div class="detail-row detail-row-full">
              <span class="detail-label">备注</span>
              <span class="detail-value">{{ detail.remark || "-" }}</span>
            </div>
          </div>
        </div>

        <!-- 租金信息 -->
        <div class="detail-section">
          <div class="detail-section-title">租金信息</div>
          <div class="detail-grid3">
            <div
              v-for="(attr, index) in attrs"
              :key="attr.code || index"
              class="detail-row"
            >
              <span class="detail-label">{{ attr.name || ("属性" + (index + 1)) }}</span>
              <span class="detail-value">{{ attrDisplay(attr) }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">标的物租金</span>
              <span class="detail-value">
                {{ detail.propertyRent != null && detail.propertyRent !== "" ? detail.propertyRent + " 元" : "-" }}
              </span>
            </div>
          </div>
        </div>

        <!-- 标的物照片（与编辑弹窗同一套预览逻辑） -->
        <div class="detail-section">
          <div class="detail-section-title">标的物照片</div>
          <lease-image-upload
            v-if="detail.photoUrl"
            :value="detail.photoUrl"
            :readonly="true"
            :limit="9"
            tip=""
          />
          <div v-else class="empty-tip">暂无照片</div>
        </div>

        <!-- 租约记录 -->
        <div class="detail-section">
          <div class="detail-section-title">租约记录</div>
          <el-table
            v-loading="contractLoading"
            :data="contractList"
            border
            size="small"
            style="width:100%"
            :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
          >
            <i slot="empty" style="font-style:normal">暂无租约记录</i>
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column prop="contractCode" label="合同编号" align="center" min-width="140" show-overflow-tooltip />
            <el-table-column prop="contractName" label="合同名称" align="center" min-width="120" show-overflow-tooltip />
            <el-table-column label="合同状态" align="center" width="100">
              <template slot-scope="scope">
                <LeaseStatusTag kind="contract" :value="scope.row.contractStatus" />
              </template>
            </el-table-column>
            <el-table-column prop="totalRent" label="鱼塘租金(元)" align="center" width="120" />
            <el-table-column label="合同时间" align="center" min-width="180">
              <template slot-scope="scope">
                {{ formatDate(scope.row.contractStart) }} 至 {{ formatDate(scope.row.contractEnd) }}
              </template>
            </el-table-column>
            <el-table-column prop="tenantName" label="承租方名称" align="center" min-width="120" show-overflow-tooltip />
            <el-table-column label="缴费情况" align="center" width="100">
              <template slot-scope="scope">
                <LeaseStatusTag kind="payment" :value="scope.row.paymentStatus" />
              </template>
            </el-table-column>
            <el-table-column prop="paymentPeriod" label="已缴次数" align="center" width="90">
              <template slot-scope="scope">
                {{ scope.row.payCount != null ? scope.row.payCount : (scope.row.paymentPeriod != null ? scope.row.paymentPeriod : "-") }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 审核流程记录 -->
        <div class="detail-section">
          <div class="detail-section-title">审核流程记录</div>
          <div v-if="auditLogs.length" class="tl">
            <div v-for="(log, idx) in auditLogs" :key="log.id || idx" class="tl-node">
              <div class="tl-dot" :class="getLogDotClass(log)"></div>
              <div class="tl-content">
                <div class="tl-title">{{ getLogTitle(log) }}</div>
                <div class="tl-info">
                  <span v-if="log.actionDesc" class="tl-info-item">{{ log.actionDesc }}</span>
                  <span class="tl-info-item">时间：{{ formatTime(log.actionTime) || "-" }}</span>
                </div>
                <div
                  v-if="log.auditRemark && isRejectAction(log)"
                  class="tl-result tl-result--reject"
                >
                  驳回原因：{{ log.auditRemark }}
                </div>
                <div v-else-if="log.auditRemark" class="tl-result">
                  备注：{{ log.auditRemark }}
                </div>
              </div>
              <div
                v-if="idx < auditLogs.length - 1"
                class="tl-line"
                :class="getLogLineClass(log)"
              ></div>
            </div>
          </div>
          <div v-else class="empty-tip">暂无审核记录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeaseImageUpload from "@/components/fishPondLease/common/LeaseImageUpload.vue";
import LeaseStatusTag from "@/components/fishPondLease/common/LeaseStatusTag.vue";
import {
  getProperty,
  listAuditLog,
  listContractByProperty,
  leaseRequestError
} from "@/service/fishPondLease.js";
import {
  PropertyType,
  AuditBusType,
  AuditActionType,
  enumLabel
} from "@/service/fishPondLeaseEnums.js";

export default {
  name: "PropertyDetail",
  components: {
    LeaseImageUpload: LeaseImageUpload,
    LeaseStatusTag: LeaseStatusTag
  },
  data: function() {
    return {
      loading: false,
      contractLoading: false,
      detail: {},
      attrs: [],
      auditLogs: [],
      contractList: []
    };
  },
  computed: {
    propertyId: function() {
      return (
        (this.$route.query && this.$route.query.id) ||
        (this.$route.params && this.$route.params.id) ||
        ""
      );
    },
    typeLabel: function() {
      var typeTxt = enumLabel("propertyType", this.detail.type);
      if (
        Number(this.detail.type) === PropertyType.FishPond &&
        this.detail.subType != null &&
        this.detail.subType !== ""
      ) {
        return typeTxt + " - " + enumLabel("propertySubType", this.detail.subType);
      }
      return typeTxt;
    },
  },
  mounted: function() {
    this.loadDetail();
  },
  methods: {
    enumLabel: enumLabel,
    attrDisplay: function(attr) {
      var val = attr.val != null && attr.val !== "" ? attr.val : "-";
      if (attr.valUnitTxt) return val + " " + attr.valUnitTxt;
      return val;
    },
    formatTime: function(val) {
      if (!val) return "";
      return String(val)
        .replace("T", " ")
        .substring(0, 19);
    },
    formatDate: function(val) {
      if (!val) return "-";
      return String(val)
        .replace("T", " ")
        .substring(0, 10);
    },
    isRejectAction: function(log) {
      var t = log.actionType;
      return (
        Number(t) === AuditActionType.Reject ||
        t === "REJECT" ||
        t === "Reject"
      );
    },
    getLogTitle: function(log) {
      var t = log.actionType;
      if (Number(t) === AuditActionType.Submit || t === "SUBMIT") {
        return "提交审核申请";
      }
      if (Number(t) === AuditActionType.Approve || t === "APPROVE") {
        return "审核通过";
      }
      if (Number(t) === AuditActionType.Reject || t === "REJECT") {
        return "审核驳回";
      }
      return log.actionTypeCn || "-";
    },
    getLogDotClass: function(log) {
      if (this.isRejectAction(log)) return "tl-dot--reject";
      var t = log.actionType;
      if (
        Number(t) === AuditActionType.Submit ||
        Number(t) === AuditActionType.Approve ||
        t === "SUBMIT" ||
        t === "APPROVE"
      ) {
        return "tl-dot--done";
      }
      return "tl-dot--pending";
    },
    getLogLineClass: function(log) {
      if (this.isRejectAction(log)) return "tl-line--reject";
      return "tl-line--done";
    },
    loadDetail: function() {
      var self = this;
      var id = this.propertyId;
      if (!id) {
        this.$message.warning("缺少标的物Id");
        return;
      }
      this.loading = true;
      getProperty(id)
        .then(function(res) {
          var data = (res && res.data) || {};
          self.detail = data;
          self.attrs = Array.isArray(data.attrs) ? data.attrs : [];
          self.loadContractList();
          return listAuditLog({ busType: AuditBusType.Property, busId: id });
        })
        .then(function(res) {
          var data = (res && res.data) || [];
          self.auditLogs = Array.isArray(data) ? data : [];
        })
        .catch(function(e) {
          self.$message.error(leaseRequestError(e));
        })
        .then(function() {
          self.loading = false;
        });
    },
    loadContractList: function() {
      var self = this;
      var id = this.propertyId;
      if (!id) {
        this.contractList = [];
        this.contractLoading = false;
        return;
      }
      this.contractLoading = true;
      listContractByProperty(id)
        .then(function(res) {
          var data = (res && res.data) || [];
          self.contractList = Array.isArray(data) ? data : [];
        })
        .catch(function(e) {
          self.contractList = [];
          self.$message.error(leaseRequestError(e));
        })
        .then(function() {
          self.contractLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.detail-body {
  padding: 16px 24px 40px;
  background: #fff;
}

.detail-section {
  margin-bottom: 22px;
}

.detail-section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.detail-grid3 {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -12px;
}

.detail-row {
  width: 33.333%;
  box-sizing: border-box;
  padding: 0 12px;
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  line-height: 32px;
  min-width: 0;
}

.detail-row-full {
  width: 100%;
}

.detail-label {
  width: 110px;
  flex-shrink: 0;
  color: #909399;
  font-size: 14px;
}

.detail-value {
  flex: 1;
  color: #303133;
  font-size: 14px;
  word-break: break-all;
  min-width: 0;
}

.detail-value-danger {
  color: #f56c6c;
}

.empty-tip {
  color: #909399;
  font-size: 14px;
  padding: 12px 0 4px;
}

/* 审核时间线（对齐参考项目） */
.tl {
  max-width: 720px;
  padding-top: 4px;
}

.tl-node {
  display: flex;
  position: relative;
}

.tl-dot {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  background: #909399;
}

.tl-dot--done {
  background: #67c23a;
  color: #fff;
  font-size: 12px;
}

.tl-dot--done::before {
  content: "\2713";
}

.tl-dot--reject {
  background: #f56c6c;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
}

.tl-dot--reject::before {
  content: "\00d7";
}

.tl-dot--pending {
  background: #909399;
}

.tl-line {
  position: absolute;
  left: 10px;
  top: 22px;
  width: 2px;
  height: 100%;
  background: #e4e7ed;
}

.tl-line--done {
  background: #67c23a;
}

.tl-line--reject {
  background: #f56c6c;
}

.tl-content {
  flex: 1;
  min-width: 0;
  padding-bottom: 20px;
}

.tl-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  line-height: 22px;
}

.tl-info {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.tl-info-item {
  font-size: 13px;
  color: #606266;
}

.tl-result {
  margin-top: 10px;
  font-size: 13px;
  font-weight: 500;
  color: #606266;
}

.tl-result--reject {
  color: #f56c6c;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  border-left: 3px solid #f56c6c;
  border-radius: 4px;
  padding: 10px 14px;
  line-height: 1.5;
}

@media screen and (max-width: 1100px) {
  .detail-row {
    width: 50%;
  }
}

@media screen and (max-width: 768px) {
  .detail-row {
    width: 100%;
  }
}
</style>
